import TableOrdering from './TableOrdering';

export default {
  TableOrdering,
};
